import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ColaTrabajoOCR } from '../model/ocr';
import { IPagination } from '../model/pagination';


@Injectable()
export class OCRService {

  constructor(
    private http: HttpClient
  ) { }

  private API_OCR = environment.API_BASE + '/OCR';

  getOCRJobs(inicio: number, fin: number): Observable<IPagination<ColaTrabajoOCR>> {
    const observable = this.http.get<IPagination<ColaTrabajoOCR>>(this.API_OCR + '/GetOCRJobs/' + inicio + '/' + fin)
      .pipe(map((cola: IPagination<ColaTrabajoOCR>) => IPagination.toModel<ColaTrabajoOCR>(JSON.stringify(cola), ColaTrabajoOCR)));
    return observable as Observable<IPagination<ColaTrabajoOCR>>;
  }

}
